import React from "react";
import FbIcon from "./icons/domino/fb_icon";

const Fb = ({item, bidib}) => {
    return (
        <FbIcon item={item} bidib={bidib}/>
    )
}

export default Fb